import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useEffect,useState } from 'react';
import ConfirmationModal from '../common/ConfirmationModal';
import CommomTable from '../common/CommonTable';
const DepartmentTable = ({ data = [], setDepartments, onEdit, setTableInstance ,onDelete,userType}) => {
    const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleConfirmDelete = () => {
    if (selectedRow) {
      onDelete(selectedRow.id);
      setConfirmOpen(false);
    }
  };
  const columns = [
    {
      accessorKey: 'name',
      header: 'Department',
      size: 180,
      minSize: 120,
      mantineTableBodyCellProps: {
        style: {
          fontFamily: 'Nunito Sans, sans-serif',
          fontWeight: 600,
          color: '#595C60',
        },
      },
    },
 ...(userType === 'sa'
    ? [{
        accessorKey: 'company_name',
        header: 'Company',
        size: 180,
        minSize: 120,
        mantineTableBodyCellProps: {
          style: {
            fontFamily: 'Nunito Sans, sans-serif',
            fontWeight: 600,
            color: '#595C60',
          },
        },
      }]
    : []),

  ];

  const table = useMantineReactTable({
    columns,
    data,
    enableRowSelection: true,
    enableStickyHeader: true,
    enableColumnResizing: true,
    enableColumnHiding: true,
    meta: {
      setDepartments,
      onEdit,
    },
  });

  // Pass the table instance to the parent
  useEffect(() => {
    if (setTableInstance) {
      setTableInstance(table);
    }
  }, [table, setTableInstance]);

  return (
    <div className="mb-5">
    
      <CommomTable data={data} 
      columns={columns}
      
        onEdit={onEdit}
        onDelete={onDelete}
      
      />
       <ConfirmationModal
        open={confirmOpen}
        onCancel={() => setConfirmOpen(false)}
        onConfirm={handleConfirmDelete}
        title="Delete Department"
        message={`Are you sure you want to delete the department "${selectedRow?.name}"?`}
      />
    </div>
  );
};

export default DepartmentTable;